import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Chief Executive officer section for eligibility tab
 */
const ChiefExecutiveOfficerSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="chief-executive-officer-section-component"
    >
      <AccordionV2
        testId="chief-executive-officer"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Chief Executive Officer" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>
            As nominees may come from any industry segment, where states of the
            market as well as measuring yardsticks differ, the criteria for
            evaluation will focus more on qualitative and behavioural traits.
          </p>

          <p>
            Specifically, the Best Chief Executive Officer nominees will be
            evaluated on the competencies listed below.
          </p>

          <p className="mb-0">
            <strong>Governance</strong>
          </p>

          <p className="mb-0">
            The CEO sets a tone of excellence in corporate governance through
            personal example and upholds a strict code of business ethics
            throughout the organisation. He/she builds high standards of
            governance, controls and accountability into the execution of
            business growth and expansion plans.
          </p>

          <p>
            He/she is able to maintain the right balance in relationship between
            board and management with a view to enhancing effectiveness. We will
            look at how the CEO acts as a true advocate of best-in-class board
            practices within the firm and in the business community.
          </p>

          <p className="mb-0">
            <strong>Performance</strong>
          </p>

          <p>
            The CEO has articulated a vision and has built strategy in
            anticipation of crisis. He/she is able to think strategically and
            lead change in the organisation to achieve that vision. Based on the
            vision, the CEO should have developed a high-impact corporate
            strategy by integrating market, competition, trends, and other
            factors to create a competitive advantage for the company. He/she
            should also have a vision and track record of building sustainable
            strategy for digital innovation and cybersecurity best practices to
            create a resilient and trusted cyber environment for the
            organisation.
          </p>

          <p className="mb-0">
            <strong>Strategy</strong>
          </p>

          <p>
            The CEO has articulated a vision and has built strategy in
            anticipation of crisis. He/she is able to think strategically and
            lead change in the organisation to achieve that vision. Based on the
            vision, the CEO should have developed a high-impact corporate
            strategy by integrating market, competition, trends, and other
            factors to create a competitive advantage for the company. He/she
            should also have a vision and track record of building sustainable
            strategy for digital innovation and cybersecurity best practices to
            create a resilient and trusted cyber environment for the
            organisation.
          </p>

          <p className="mb-0">
            <strong>
              Succession Planning, Talent Management & Development
            </strong>
          </p>

          <p>
            The CEO is the key driver of talent management. He/she should have
            succession planning, particularly at the C-suite level, at the
            forefront of his/her agenda, and actively identifies and develops
            the next generation of the executive team. The CEO systematically
            builds team capability, in terms of understanding the capabilities
            of immediate team members and reaching out to develop promising team
            members at other levels. He/she ensures the organisation trains and
            nurtures talent with a view to retaining institutional domain
            knowledge. He/she also creates corporate cultures that are diverse
            and inclusive.
          </p>

          <p className="mb-0">
            <strong>Corporate Social Responsibility</strong>
          </p>

          <p>
            The CEO is committed to making a positive impact on the economic,
            social and environmental well-being of the society in which his/her
            business operates. He/she promotes greater environmental
            responsibility, corporate philanthropy, volunteerism and community
            outreach programmes. He/she fosters the practice of corporate social
            purpose and sustainability within the organisation.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ChiefExecutiveOfficerSection;
